@if (HasRequiredPermissions) {
  <div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">
    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ `entities.pointOfService.pluralName` | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
      </h1>
    </div>
    <app-list-view [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
                   [pagination]="{
                          enabled: true,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: null,
                          sortableColumns: null
                        }"
      [paginatorType]="'button'"
      [showHeader]="false"
      (createButtonClick)="openCreateModal()">
      <!-- Colonne Image -->
      <app-list-table-column key="imageLogo" title="{{ 'image' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <div class="w-12 h-12 bg-gray-100 rounded flex items-center justify-center overflow-hidden">
            @if (entity.imageLogo?.thumbnail_Path) {
              <img [src]="rootUrl + entity.imageLogo.thumbnail_Path" alt="Logo" class="w-full h-full object-contain">
            } @else {
              <span class="text-gray-400 italic text-xs">No logo</span>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <!-- Colonne Name -->
      <app-list-table-column key="name" title="{{ 'entities.pointOfService.propreties.name' | translate }}" type="text"
      [sortable]="true" align="left"></app-list-table-column>
      <!-- Colonne Custom URL (prefix) -->
      <app-list-table-column key="prefix" title="{{ 'entities.pointOfService.propreties.prefix' | translate }}"
      type="text" [sortable]="true" align="left"></app-list-table-column>
    </app-list-view>
    <!--Vue de detail-->
    <div class="fixed top-0 right-0 h-full z-50 min-w-[80%]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">
      <!-- Poignee interactive (invisible avant le survol)  -->
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="h-full flex flex-col">
        <div class="bg-white rounded-lg shadow-xl p-1 flex-1 flex flex-col min-h-0 h-full">
          <app-pos-detail #pointOfServiceDetail
            class="h-full block"
            (closeModal)="closeModal($event)"
            (itemSaved)="onItemUpdated($event)"
            [isModal]="true"
            [dataService]="dataService"
            (databaseUpdated)="closeModal(true)"
            [EntityInstance]="selectedItem()">
          </app-pos-detail>
        </div>
      </div>
    </div>
  </div>
}
